module.exports = __webpack_public_path__ + "img/zk-icon-Price-bundling.a17f963b.svg";